import { toast } from 'react-toastify';

interface IItem {
  id: string;
  data: any;
}

class IndexedDBService {
  private db: IDBDatabase | null = null;
  private dbName: string;
  private storeName: string;

  constructor(dbName: string, storeName: string) {
    this.dbName = dbName;
    this.storeName = storeName;
  }

  async init(): Promise<void> {
    const request = indexedDB.open(this.dbName, 1);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = request.result;
      if (!db.objectStoreNames.contains(this.storeName)) {
        db.createObjectStore(this.storeName, { keyPath: "id" });
      }
    };

    await new Promise((resolve, reject) => {
      request.onsuccess = () => {
        this.db = request.result;
        resolve(request.result);
      };
      request.onerror = () => {
        reject(new Error(`IndexedDB error: ${request.error?.message}`));
      };
    });
  }

  async createItem(item: IItem): Promise<void> {
    if(this.db === null) {
      await this.init()
    }
    if (!this.db) {
      throw new Error("The database has not been initialized.");
    }
    const transaction = this.db.transaction(this.storeName, 'readwrite');
    const store = transaction.objectStore(this.storeName);
    const request = store.add(item);

    await new Promise((resolve, reject) => {
      request.onsuccess = () => {
        // toast.success("Item added successfully!");
        resolve(request.result);
      };
      request.onerror = () => {
        toast.error("Failed to add item.");
        reject(request.error);
      };
    });
  }

  async readItem(id: string): Promise<IItem> {
    if(this.db === null) {
      await this.init()
    }
    if (!this.db) {
      throw new Error("The database has not been initialized.");
    }
    const transaction = this.db.transaction(this.storeName, 'readonly');
    const store = transaction.objectStore(this.storeName);
    const request = store.get(id);

    return await new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
  async clearStore(): Promise<void> {
    if(this.db === null) {
      await this.init()
    }
    if (!this.db) {
      throw new Error("The database has not been initialized.");
    }
    const transaction = this.db.transaction(this.storeName, 'readwrite');
    const store = transaction.objectStore(this.storeName);
    const request = store.clear();

    await new Promise((resolve, reject) => {
      request.onsuccess = () => {
        // toast.success("All items cleared successfully!");
        resolve(request.result);
      };
      request.onerror = () => {
        toast.error("Falla en la inicialización de la base de datos");
        reject(request.error);
      };
    });
  }
}

export default IndexedDBService;
